<template>
    <b-form-group :label="label" :invalid-feedback="error" :state="state" class="form-date-range-picker">
        <date-range-picker v-on="listeners" v-bind="attrs" :state="state" :value="value" @input="input" />
    </b-form-group>
</template>

<script>
    import DateRangePicker from '../date-range-picker/date-range-picker.vue';

    export default {
        name: 'FormDateRangePicker',
        components: {
            DateRangePicker,
        },
        props: {
            value: {
                type: Object,
                default: {},
            },
            label: {
                type: String,
                default: null,
            },
            error: {
                type: String,
                default: null,
            },
        },
        computed: {
            state() {
                if (this.error) {
                    return !this.error;
                }
            },
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            input(value) {
                this.$emit('input', value);
            },
        },
    };
</script>

<style lang="scss">
    .form-date-range-picker {
        .dropdown {
            width: 100%;
            margin: 0;
        }
        .lx-date-range-picker__button {
            width: unset;
            white-space: nowrap;
        }
        .dropdown-toggle {
            text-align: left !important;
            &::after {
                position: absolute;
                top: calc(50% - 0.15em);
                right: 0.75rem;
            }
        }
    }
</style>
